import { tv } from 'tailwind-variants'

export const appHeaderStyles = tv({
	base: 'justify-between items-center bg-palette_2 z-10 lg:h-24 w-full',
})
